import "core-js/es/promise/with-resolvers";
import {parseJSON as $42h8L$parseJSON, likeArray as $42h8L$likeArray, stringifyDOM as $42h8L$stringifyDOM, formToJSON as $42h8L$formToJSON, isTypedArray as $42h8L$isTypedArray, createAsyncIterator as $42h8L$createAsyncIterator} from "web-utility";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $eef213ff4197108b$exports = {};

$parcel$export($eef213ff4197108b$exports, "Stack", function () { return $eef213ff4197108b$export$694e0d28c7ffc90c; });
const { push: $eef213ff4197108b$var$push } = Array.prototype;
class $eef213ff4197108b$export$694e0d28c7ffc90c {
    use(...middlewares) {
        $eef213ff4197108b$var$push.apply(this, middlewares);
        return this;
    }
    execute(context, depth = 0) {
        const middleware = this[depth];
        if (middleware instanceof Function) return middleware(context, this.execute.bind(this, context, ++depth));
    }
    mount(condition, stack) {
        return this.use((context, next)=>condition(context) ? stack.execute(context) : next());
    }
    constructor(){
        this.length = 0;
    }
}


var $0fe1f1400993ba8a$exports = {};

$parcel$export($0fe1f1400993ba8a$exports, "BodyRequestMethods", function () { return $0fe1f1400993ba8a$export$4125cfe7e08e2040; });
$parcel$export($0fe1f1400993ba8a$exports, "HTTPError", function () { return $0fe1f1400993ba8a$export$aa9d629c530f62a7; });
$parcel$export($0fe1f1400993ba8a$exports, "headerParser", function () { return $0fe1f1400993ba8a$export$b725a69477e4d33f; });
$parcel$export($0fe1f1400993ba8a$exports, "parseHeaders", function () { return $0fe1f1400993ba8a$export$eea2c1c5e1a37e50; });
$parcel$export($0fe1f1400993ba8a$exports, "parseBody", function () { return $0fe1f1400993ba8a$export$3b629cd0ff482602; });
$parcel$export($0fe1f1400993ba8a$exports, "requestXHR", function () { return $0fe1f1400993ba8a$export$4f2a8c8c11a6373a; });
$parcel$export($0fe1f1400993ba8a$exports, "requestFetch", function () { return $0fe1f1400993ba8a$export$bda27a3e49197b9; });
$parcel$export($0fe1f1400993ba8a$exports, "parseResponse", function () { return $0fe1f1400993ba8a$export$ba14d9a5a581e827; });
$parcel$export($0fe1f1400993ba8a$exports, "iterateFetchBody", function () { return $0fe1f1400993ba8a$export$a95ada708dd8b125; });
$parcel$export($0fe1f1400993ba8a$exports, "parseFetchBody", function () { return $0fe1f1400993ba8a$export$b7b86d31099674dc; });
$parcel$export($0fe1f1400993ba8a$exports, "request", function () { return $0fe1f1400993ba8a$export$b5fe3f66a567bec0; });


var $22de11b45b0eeb97$exports = {};

$parcel$export($22de11b45b0eeb97$exports, "parseDocument", function () { return $22de11b45b0eeb97$export$b6a9369736b19f4d; });
$parcel$export($22de11b45b0eeb97$exports, "makeFormData", function () { return $22de11b45b0eeb97$export$2c28ab2e118e73f1; });
$parcel$export($22de11b45b0eeb97$exports, "serializeNode", function () { return $22de11b45b0eeb97$export$a0beee2e55fb5dd1; });
$parcel$export($22de11b45b0eeb97$exports, "serialize", function () { return $22de11b45b0eeb97$export$dfdc1655ccc5b9cb; });
$parcel$export($22de11b45b0eeb97$exports, "streamFromProgress", function () { return $22de11b45b0eeb97$export$f8162fcba31fa547; });
$parcel$export($22de11b45b0eeb97$exports, "FileMethod", function () { return $22de11b45b0eeb97$export$226b21d2db5eaf9f; });
$parcel$export($22de11b45b0eeb97$exports, "readAs", function () { return $22de11b45b0eeb97$export$e209cbb66c5b18c; });
$parcel$export($22de11b45b0eeb97$exports, "encodeBase64", function () { return $22de11b45b0eeb97$export$8fb536984ec8b4d7; });

if (typeof globalThis.AbortSignal === "function") {
    /**
     * @see {@link https://github.com/mo/abortcontroller-polyfill/issues/70}
     */ AbortSignal.prototype.throwIfAborted ||= function() {
        const { aborted: aborted, reason: reason = "Aborted" } = this;
        if (!aborted) return;
        throw reason instanceof DOMException ? reason : new DOMException(reason instanceof Error ? reason.message : reason + "", "AbortError");
    };
    /**
     * @see {@link https://github.com/mo/abortcontroller-polyfill/issues/73#issuecomment-2085543258}
     */ AbortSignal.any ||= (iterable)=>{
        const controller = new AbortController();
        function abort() {
            controller.abort(this.reason);
            clean();
        }
        function clean() {
            for (const signal of iterable)signal.removeEventListener("abort", abort);
        }
        for (const signal of iterable)if (signal.aborted) {
            controller.abort(signal.reason);
            break;
        } else signal.addEventListener("abort", abort);
        return controller.signal;
    };
}
async function $22de11b45b0eeb97$export$b6a9369736b19f4d(text, contentType = "") {
    const [type] = contentType?.split(";") || [];
    return new DOMParser().parseFromString(text, type || "text/html");
}
function $22de11b45b0eeb97$export$2c28ab2e118e73f1(data) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)){
        const list = typeof value !== "string" && (0, $42h8L$likeArray)(value) ? value : [
            value
        ];
        for (const item of Array.from(list))if (item != null) {
            if (typeof item === "object") formData.append(key, item, item.name);
            else formData.append(key, item);
        }
    }
    return formData;
}
function $22de11b45b0eeb97$export$a0beee2e55fb5dd1(root) {
    var contentType;
    if (!(root instanceof HTMLFormElement)) return {
        contentType: root instanceof SVGElement ? "image/svg" : root instanceof HTMLDocument || root instanceof HTMLElement ? "text/html" : "application/xml",
        data: (0, $42h8L$stringifyDOM)(root)
    };
    if (root.querySelector('input[type="file"][name]')) return {
        contentType: "multipart/form-data",
        data: new FormData(root)
    };
    const data = (0, $42h8L$formToJSON)(root);
    switch(contentType = root.enctype){
        case "text/plain":
            return {
                contentType: contentType,
                data: Object.entries(data).map(([name, value])=>`${name}=${value}`).join("\n")
            };
        case "application/x-www-form-urlencoded":
            return {
                contentType: contentType,
                data: new URLSearchParams(data) + ""
            };
        default:
            return {
                contentType: "application/json",
                data: JSON.stringify(data)
            };
    }
}
function $22de11b45b0eeb97$export$dfdc1655ccc5b9cb(data, contentType) {
    const [type] = contentType?.split(";") || [];
    switch(type){
        case "application/x-www-form-urlencoded":
            return {
                contentType: contentType,
                data: new URLSearchParams(data)
            };
        case "multipart/form-data":
            return {
                data: $22de11b45b0eeb97$export$2c28ab2e118e73f1(data)
            };
        case "application/json":
            return {
                contentType: contentType,
                data: JSON.stringify(data)
            };
        case "text/html":
        case "application/xml":
        case "image/svg":
            return {
                contentType: contentType,
                data: (0, $42h8L$stringifyDOM)(data)
            };
    }
    if (type) return {
        data: data,
        contentType: contentType
    };
    try {
        if (data instanceof URLSearchParams) return {
            contentType: "application/x-www-form-urlencoded",
            data: data
        };
    } catch  {}
    try {
        if (data instanceof FormData) return {
            data: data
        };
    } catch  {}
    try {
        if (data instanceof Node) return $22de11b45b0eeb97$export$a0beee2e55fb5dd1(data);
    } catch  {}
    try {
        if ((0, $42h8L$isTypedArray)(data) || data instanceof ArrayBuffer || data instanceof DataView || data instanceof Blob || data instanceof ReadableStream) return {
            contentType: "application/octet-stream",
            data: data
        };
    } catch  {}
    try {
        return {
            contentType: "application/json",
            data: JSON.stringify(data)
        };
    } catch  {}
    throw new Error("Unserialized Object needs a specific Content-Type");
}
const $22de11b45b0eeb97$export$f8162fcba31fa547 = (target)=>(0, $42h8L$createAsyncIterator)(({ next: next, complete: complete, error: error })=>{
        const handleProgress = ({ loaded: loaded, total: total })=>{
            if (loaded < total) next({
                loaded: loaded,
                total: total
            });
            else {
                if (loaded === total) next({
                    loaded: loaded,
                    total: total
                });
                complete();
            }
        };
        target.addEventListener("progress", handleProgress);
        target.addEventListener("error", error);
        return ()=>{
            target.removeEventListener("progress", handleProgress);
            target.removeEventListener("error", error);
        };
    });
var $22de11b45b0eeb97$export$226b21d2db5eaf9f;
(function(FileMethod) {
    FileMethod["text"] = "readAsText";
    FileMethod["dataURL"] = "readAsDataURL";
    FileMethod["binaryString"] = "readAsBinaryString";
    FileMethod["arrayBuffer"] = "readAsArrayBuffer";
})($22de11b45b0eeb97$export$226b21d2db5eaf9f || ($22de11b45b0eeb97$export$226b21d2db5eaf9f = {}));
function $22de11b45b0eeb97$export$e209cbb66c5b18c(file, method, encoding) {
    const reader = new FileReader();
    const result = new Promise((resolve, reject)=>{
        reader.onerror = reject;
        reader.onload = ()=>resolve(reader.result);
        reader[$22de11b45b0eeb97$export$226b21d2db5eaf9f[method]](file, encoding);
    });
    return {
        progress: $22de11b45b0eeb97$export$f8162fcba31fa547(reader),
        result: result
    };
}
const $22de11b45b0eeb97$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
async function $22de11b45b0eeb97$export$8fb536984ec8b4d7(raw) {
    if (raw instanceof Blob) {
        const text = await $22de11b45b0eeb97$export$e209cbb66c5b18c(raw, "dataURL").result;
        return ($22de11b45b0eeb97$var$DataURI.exec(text) || "")[4];
    }
    const text = encodeURIComponent(raw).replace(/%([0-9A-F]{2})/g, (_, p1)=>String.fromCharCode(+("0x" + p1)));
    return btoa(text);
}


var $0fe1f1400993ba8a$export$4125cfe7e08e2040;
(function(BodyRequestMethods) {
    BodyRequestMethods["POST"] = "POST";
    BodyRequestMethods["PUT"] = "PUT";
    BodyRequestMethods["PATCH"] = "PATCH";
    BodyRequestMethods["DELETE"] = "DELETE";
})($0fe1f1400993ba8a$export$4125cfe7e08e2040 || ($0fe1f1400993ba8a$export$4125cfe7e08e2040 = {}));
class $0fe1f1400993ba8a$export$aa9d629c530f62a7 extends URIError {
    constructor(message, request, response){
        super(message);
        this.request = request;
        this.response = response;
    }
}
const $0fe1f1400993ba8a$export$b725a69477e4d33f = {
    Link: (value)=>Object.fromEntries(Array.from(value.matchAll(/<(\S+?)>; rel="(\w+)"(?:; title="(.*?)")?/g), ([_, URI, rel, title])=>[
                rel,
                {
                    rel: rel,
                    URI: URI,
                    title: title
                }
            ]))
};
const $0fe1f1400993ba8a$export$eea2c1c5e1a37e50 = (raw)=>Object.fromEntries(Array.from(raw.trim().matchAll(/^([\w-]+):\s*(.*)/gm), ([_, key, value])=>{
        key = key.replace(/(^[a-z]|-[a-z])/g, (char)=>char.toUpperCase());
        return [
            key,
            $0fe1f1400993ba8a$export$b725a69477e4d33f[key]?.(value) ?? value
        ];
    }));
function $0fe1f1400993ba8a$export$3b629cd0ff482602(raw, contentType) {
    if (contentType.includes("json")) return (0, $42h8L$parseJSON)(raw);
    if (contentType.match(/html|xml/)) try {
        return (0, $22de11b45b0eeb97$export$b6a9369736b19f4d)(raw, contentType);
    } catch  {}
    if (contentType.includes("text")) return raw;
    return new TextEncoder().encode(raw).buffer;
}
function $0fe1f1400993ba8a$export$4f2a8c8c11a6373a({ method: method = "GET", path: path, headers: headers = {}, body: body, signal: signal, ...rest }) {
    const request = new XMLHttpRequest(), header_list = headers instanceof Array ? headers : headers?.[Symbol.iterator] instanceof Function ? [
        ...headers
    ] : Object.entries(headers);
    const abort = ()=>request.abort();
    signal?.addEventListener("abort", abort);
    const response = new Promise((resolve, reject)=>{
        request.onreadystatechange = ()=>{
            const { readyState: readyState, status: status, statusText: statusText, responseType: responseType } = request;
            if (readyState !== 4 || !status && !signal?.aborted) return;
            resolve({
                status: status,
                statusText: statusText,
                headers: $0fe1f1400993ba8a$export$eea2c1c5e1a37e50(request.getAllResponseHeaders()),
                body: responseType && responseType !== "text" ? request.response : request.responseText
            });
        };
        request.onerror = request.ontimeout = reject;
        request.open(method, path + "");
        for (const [key, value] of header_list)request.setRequestHeader(key, value);
        Object.assign(request, rest);
        request.send(body);
    }).then(({ body: body, ...meta })=>{
        signal?.throwIfAborted();
        const contentType = request.getResponseHeader("Content-Type") || "";
        if (typeof body === "string" && !contentType.includes("text")) body = $0fe1f1400993ba8a$export$3b629cd0ff482602(body, contentType);
        return {
            ...meta,
            body: body
        };
    });
    response.finally(()=>signal?.removeEventListener("abort", abort));
    return {
        response: response,
        upload: (0, $22de11b45b0eeb97$export$f8162fcba31fa547)(request.upload),
        download: (0, $22de11b45b0eeb97$export$f8162fcba31fa547)(request)
    };
}
function $0fe1f1400993ba8a$export$bda27a3e49197b9({ path: path, method: method, headers: headers, withCredentials: withCredentials, body: body, signal: signal, timeout: timeout, responseType: responseType }) {
    const signals = [
        signal,
        timeout && AbortSignal.timeout(timeout)
    ].filter(Boolean);
    headers = headers instanceof Headers ? Object.fromEntries(headers.entries()) : headers instanceof Array ? Object.fromEntries(headers) : headers;
    headers = responseType === "text" ? {
        ...headers,
        Accept: "text/plain"
    } : responseType === "json" ? {
        ...headers,
        Accept: "application/json"
    } : responseType === "document" ? {
        ...headers,
        Accept: "text/html, application/xhtml+xml, application/xml"
    } : responseType === "arraybuffer" || responseType === "blob" ? {
        ...headers,
        Accept: "application/octet-stream"
    } : headers;
    const responsePromise = fetch(path + "", {
        method: method,
        headers: headers,
        credentials: withCredentials ? "include" : "omit",
        body: body,
        signal: signals[0] && AbortSignal.any(signals)
    });
    return {
        response: $0fe1f1400993ba8a$export$ba14d9a5a581e827(responsePromise, responseType),
        download: $0fe1f1400993ba8a$export$a95ada708dd8b125(responsePromise)
    };
}
async function $0fe1f1400993ba8a$export$ba14d9a5a581e827(responsePromise, responseType) {
    const { status: status, statusText: statusText, headers: headers, body: body } = (await responsePromise).clone();
    const contentType = headers.get("Content-Type") || "";
    const header = $0fe1f1400993ba8a$export$eea2c1c5e1a37e50([
        ...headers
    ].map(([key, value])=>`${key}: ${value}`).join("\n"));
    const rBody = status === 204 ? undefined : await $0fe1f1400993ba8a$export$b7b86d31099674dc(body, contentType, responseType);
    return {
        status: status,
        statusText: statusText,
        headers: header,
        body: rBody
    };
}
async function $0fe1f1400993ba8a$export$b7b86d31099674dc(stream, contentType, responseType) {
    const chunks = [];
    for await (const chunk of stream)chunks.push(chunk);
    const blob = new Blob(chunks, {
        type: contentType
    });
    if (responseType === "blob") return blob;
    if (responseType === "arraybuffer") return blob.arrayBuffer();
    const text = await blob.text();
    if (responseType === "text") return text;
    return $0fe1f1400993ba8a$export$3b629cd0ff482602(text, contentType);
}
async function* $0fe1f1400993ba8a$export$a95ada708dd8b125(responsePromise) {
    const { headers: headers, body: body } = (await responsePromise).clone();
    const total = +headers.get("Content-Length");
    var loaded = 0;
    for await (const { byteLength: byteLength } of body){
        loaded += byteLength;
        yield {
            total: total,
            loaded: loaded
        };
    }
}
const $0fe1f1400993ba8a$export$b5fe3f66a567bec0 = typeof globalThis.XMLHttpRequest === "function" ? $0fe1f1400993ba8a$export$4f2a8c8c11a6373a : $0fe1f1400993ba8a$export$bda27a3e49197b9;


var $cbd22d3323bef9ca$exports = {};

$parcel$export($cbd22d3323bef9ca$exports, "HTTPClient", function () { return $cbd22d3323bef9ca$export$45cf759b359d3d24; });



const { splice: $cbd22d3323bef9ca$var$splice } = Array.prototype;
class $cbd22d3323bef9ca$export$45cf759b359d3d24 extends (0, $eef213ff4197108b$export$694e0d28c7ffc90c) {
    constructor({ baseURI: baseURI = globalThis.document?.baseURI, baseRequest: baseRequest = (0, $0fe1f1400993ba8a$export$b5fe3f66a567bec0), ...options } = {}){
        super();
        this.defaultWare = async ({ request: request, response: response }, next)=>{
            const { method: method = "GET", headers: headers = {}, body: body } = request;
            if (method in (0, $0fe1f1400993ba8a$export$4125cfe7e08e2040) && body && typeof body === "object") {
                const { contentType: contentType, data: data } = (0, $22de11b45b0eeb97$export$dfdc1655ccc5b9cb)(body, headers["Content-Type"]);
                if (contentType) headers["Content-Type"] = contentType;
                request.body = data;
            }
            await next();
            if (response.status > 299) throw new (0, $0fe1f1400993ba8a$export$aa9d629c530f62a7)(response.statusText, request, response);
        };
        this.baseURI = baseURI;
        this.baseRequest = baseRequest;
        this.options = options;
        super.use(this.defaultWare);
        super.use(async ({ request: data, response: response })=>{
            data.path = new URL(data.path + "", this.baseURI) + "";
            Object.assign(response, await this.baseRequest({
                ...options,
                ...data
            }).response);
        });
    }
    use(...middlewares) {
        $cbd22d3323bef9ca$var$splice.call(this, -2, 0, ...middlewares);
        return this;
    }
    async request(data) {
        const context = {
            request: {
                ...data,
                headers: {
                    ...data.headers
                }
            },
            response: {}
        };
        await this.execute(context);
        return context.response;
    }
    async head(path, headers, options) {
        const { headers: data } = await this.request({
            method: "HEAD",
            path: path,
            headers: headers,
            ...options
        });
        return data;
    }
    get(path, headers, options) {
        return this.request({
            method: "GET",
            path: path,
            headers: headers,
            ...options
        });
    }
    post(path, body, headers, options) {
        return this.request({
            method: "POST",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    put(path, body, headers, options) {
        return this.request({
            method: "PUT",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    patch(path, body, headers, options) {
        return this.request({
            method: "PATCH",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    delete(path, body, headers, options) {
        return this.request({
            method: "DELETE",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    async *download(path, { headers: headers, chunkSize: chunkSize = 1024 ** 2, range: [start = 0, end = Infinity] = [], ...options } = {}) {
        var total = 0;
        function setEndAsHeader(length) {
            total = length;
            if (end === Infinity) end = total;
        }
        try {
            const { "Content-Length": length } = await this.head(path, headers, options);
            setEndAsHeader(+length);
        } catch (error) {
            console.error(error);
        }
        for(let i = start, j = i - 1 + chunkSize; i < end; i = j + 1, j += chunkSize){
            const { status: status, headers: { "Content-Range": range }, body: body } = await this.get(path, {
                ...headers,
                Range: `bytes=${i}-${j}`
            }, options);
            const totalBytes = +range?.split("/").pop();
            if (totalBytes) setEndAsHeader(totalBytes);
            if (status !== 206) {
                yield {
                    total: total,
                    loaded: total,
                    percent: 100,
                    buffer: body
                };
                break;
            }
            const loaded = i + body.byteLength;
            yield {
                total: total,
                loaded: loaded,
                percent: +(loaded / total * 100).toFixed(2),
                buffer: body
            };
        }
    }
}





export {$eef213ff4197108b$export$694e0d28c7ffc90c as Stack, $0fe1f1400993ba8a$export$4125cfe7e08e2040 as BodyRequestMethods, $0fe1f1400993ba8a$export$aa9d629c530f62a7 as HTTPError, $0fe1f1400993ba8a$export$b725a69477e4d33f as headerParser, $0fe1f1400993ba8a$export$eea2c1c5e1a37e50 as parseHeaders, $0fe1f1400993ba8a$export$3b629cd0ff482602 as parseBody, $0fe1f1400993ba8a$export$4f2a8c8c11a6373a as requestXHR, $0fe1f1400993ba8a$export$bda27a3e49197b9 as requestFetch, $0fe1f1400993ba8a$export$ba14d9a5a581e827 as parseResponse, $0fe1f1400993ba8a$export$a95ada708dd8b125 as iterateFetchBody, $0fe1f1400993ba8a$export$b7b86d31099674dc as parseFetchBody, $0fe1f1400993ba8a$export$b5fe3f66a567bec0 as request, $cbd22d3323bef9ca$export$45cf759b359d3d24 as HTTPClient, $22de11b45b0eeb97$export$b6a9369736b19f4d as parseDocument, $22de11b45b0eeb97$export$2c28ab2e118e73f1 as makeFormData, $22de11b45b0eeb97$export$a0beee2e55fb5dd1 as serializeNode, $22de11b45b0eeb97$export$dfdc1655ccc5b9cb as serialize, $22de11b45b0eeb97$export$f8162fcba31fa547 as streamFromProgress, $22de11b45b0eeb97$export$226b21d2db5eaf9f as FileMethod, $22de11b45b0eeb97$export$e209cbb66c5b18c as readAs, $22de11b45b0eeb97$export$8fb536984ec8b4d7 as encodeBase64};
//# sourceMappingURL=index.esm.js.map
